export default {
  locale: 'zh-cn',
  common: {
    okText: 'OK',
    cancelText: 'Cancel',
    openText: 'Open',
    closeText: 'Close',
    loadingText: 'Loading...',
    loadMoreText: 'Load more',
    moreText: 'More',
    allText: 'All',
    emptyText: 'Empty',
    saveText: 'Save',
    resetText: 'Reset',
    searchText: 'Search',
    queryText: 'Search',
    inputText: 'Please enter ',
    chooseText: 'Please choose ',
    selectAllText: 'Select all',
    selectedText: 'Selected',
    clearText: 'Clear',
    redo: 'Refresh',
    back: 'Back',
    addSuccess: 'Add Success',
    updateSuccess: 'Update Success',
    deleteSuccess: 'Delete Success',
    finish: 'Finish',
    next: 'Next',
    submit: 'Submite',
    action: 'Action',
    actions: 'Actions',
    creator: 'creator',
    createTime: 'Create Time',
    updator: 'Update Person',
    updateTime: 'Update Time',
    addText: 'Add',
    editText: 'Edit',
    delText: 'Delete',
    delConfirm: 'Comfirm delete?',
    importText: 'Import',
    exportText: 'Export',
    success: 'Success',
    tips: 'Tips',
    greater: 'Greater',
    less: 'Less',
    httpError: 'Http has some error, please contact system admin',
    notAuthorised: 'User not be authorised',
    required: 'required',
    clear: 'Clear',
    clearAll: 'Clear all',
  },
  countButton: {
    text1: 'Send verification code',
    text2: 'After {0} second.',
  },
  modal: {
    '1': 'Reset',
    '2': 'Maximize',
  },
  follow: {
    '1': 'Follow',
    '2': 'Followed',
    '3': 'Cancle success！',
    '4': 'Follow success！',
  },
  icon: {
    '1': 'Click to select icon',
    '2': 'Copy icon successfully',
  },

  time: {
    '1': 'Before',
    '2': 'After',
    '3': 'Just now',
    '4': 'Second',
    '5': 'Minute',
    '6': 'Hour',
    '7': 'Day',
    '8': 'Today',
    '9': 'This week',
    '10': 'This month',
    '11': 'This quarter',
    '12': 'This year',
    '13': 'Last week',
    '14': 'Last month',
    '15': 'Last quarter',
    '16': 'Last year',
    '17': 'First quarter',
    '18': 'Second quater',
    '19': 'Third quater',
    '20': 'Fourth quater',
  },
  member: {
    '1': 'Department',
    '2': 'Member',
    '3': 'Member select',
    '4': 'Frozen',
    '5': 'Selected',
    '6': 'Clear selection',
    '7': 'Confirm to clear the selected uers?',
    '8': 'Male',
    '9': 'Female',
    '10': '', // 这个空不能删！
    '11': 'Pleace enter user name',
    '12': 'Other',
    '13': 'Secrecy',
  },
  tree: {
    '1': 'Expand all',
    '2': 'Collapse all',
    '3': 'Select all',
    '4': 'Deselect all',
    '5': 'Hierarchical relationship',
    '6': 'Independent hierarchy',
  },
  tablePro: {
    filter: {
      '1': 'More Filter',
    },
    setting: {
      '1': 'Columns setting',
      '2': 'Fixed columns',
      '3': 'Drop columns',
      '4': 'Selection status',
      '5': 'Export settings',
      '6': 'Statistics',
      '7': 'Checked data',
    },
    export: {
      '1': 'File name',
      '1p': 'Please enter File name',
      '2': 'Serial',
      '2p': 'Please select whether to generate a table serial number column.',
      '2o1': 'Auto generate',
      '2o2': 'Do not generate',
      '3': 'File type',
      '3p': 'Please select File type',
      '4': 'File data',
      '4p': 'Please select File data',
      '4o1': 'Selected data for the current page',
      '4o2': 'All data of the current page',
      '4o3': 'All data',
      '4o4': 'All data by search',
      '5': 'File fields',
      '5p': 'Please select the file fields to export.',
      '6': 'Data processing',
    },
    columns: { '1': 'No.', '2': 'Selecte' },
    page: { '1': 'Prev', '2': 'Next' },
    message: {
      '1': 'Table saved successfully.',
      '2': 'Table save failed, please refresh and try again！',
      '3': 'Do not allow dragging into fixed columns.',
      '4': 'Do not allow merging columns.',
      '5': 'row(s) selected',
    },
  },
  form: {
    inputRange: {
      '1': 'The minimum range should be less than maximum range',
      '2': 'The maximum range should be more than minimum range',
      '3': 'Please enter number',
    },
    message: {
      '1': 'Please enter at least two words to research',
      '2': 'Please select year',
    },
  },
  file: {
    filter: {
      '1': 'Please input file name',
      '2': 'File type',
      '3': 'File name',
    },
    actions: {
      '1': 'View',
      '2': 'Download',
      '3': 'Download source file',
      '31': 'Source..',
      '4': 'Download watermark file',
      '41': 'Watermark..',
      '5': 'Update',
      '6': 'Delete',
      '7': 'Log',
    },
    columns: {
      '1': 'File name',
      '2': 'File type',
      '3': 'File size',
      '4': 'Version',
      '5': 'File Owner',
      '6': 'Upload time',
      '7': 'Updater',
      '8': 'Update time',
      '9': 'Link address',
      '10': 'Upload trigger',
      '11': 'Operation',
      '12': 'Applier',
      '13': 'Consumer',
      '14': 'Operator',
      '15': 'Operation Time',
    },
    upload: {
      '1': 'Upload file',
      '2': 'Cancel upload',
      '3': 'Upload link',
      '4': 'Too large',
      '5': 'File name contains illegal char: ',
      '6': 'Not support file type',
      '7': 'Preview file',
      '8': 'Delete file',
    },
    message: {
      '1': 'The preview of this format is temporarily not supported.',
      '2': 'File request is in progress, please wait a moment.',
      '3': 'Delete failed!',
      '4': 'Maximum number of files to upload',
      '5': 'Please select the file type.',
      '6': 'Upload successfully!',
      '7': 'Please enter the correct link',
      '8': 'Update successfully!',
      '9': 'Confirm delete?',
      '10': 'will not upload!',
      '11': 'Upload failed!',
    },
    download: {
      '1': 'Please select file which you want to download',
      '2': 'Multiple download',
    },
    modal: {
      '1': 'Version List',
      '2': 'Log List',
    },
    cards: {
      '1': 'Upload',
      '2': 'Uploaded',
    },
  },
}
